import { render, staticRenderFns } from "./NuevoObjetivo.vue?vue&type=template&id=f212900a&"
import script from "./NuevoObjetivo.vue?vue&type=script&lang=js&"
export * from "./NuevoObjetivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports